import { Component } from '@angular/core';
import { AccessDoorTypeService } from '../../../services/access-door-type.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccessDoorType } from '../../../models/access-door-type.model';
import { AccessDoorTypeModalComponent } from '../../../components/access-door-type-modal/access-door-type-modal.component';

@Component({
  selector: 'app-access-door-types-page',
  templateUrl: './access-door-types-page.component.html',
  styleUrl: './access-door-types-page.component.scss'
})
export class AccessDoorTypesPageComponent {

  constructor(
    public accessDoorTypeService: AccessDoorTypeService,
    private modalService: NgbModal,
  ) {}

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  // region delete
  async delete(
    accessDoorType: AccessDoorType
  ) {
    const flag = confirm(`¿Está seguro que desea borrar el tipo de puerta "${accessDoorType.accessDoorType}"?`);
    if (flag) {
      await this.accessDoorTypeService.delete(accessDoorType);
    }
  }

  /*
   ██████╗ ██████╗ ███████╗███╗   ██╗
  ██╔═══██╗██╔══██╗██╔════╝████╗  ██║
  ██║   ██║██████╔╝█████╗  ██╔██╗ ██║
  ██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║
  ╚██████╔╝██║     ███████╗██║ ╚████║
   ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝

  */
  // region open
  open() {
    this.modalService.open(AccessDoorTypeModalComponent);
  }
}
